<!-- 選擇產品群組項目 -->
<ng-template #Modal let-data let-ref="dialogRef">
    <nb-card class="staffInfoTemplate" [nbSpinner]="info.IsLoding">
      <nb-card-header>
        選擇商品種類
      </nb-card-header>
      <nb-card-body class="staffInfoTemplate">
  
        <!-- <div class="row mx-0 mt-3">
          <input  class="col"  [(ngModel)]="query.searchKey" name="searchKey" type="text" nbInput fullWidth 
            shape="rectangle" placeholder="輸入產品名稱">           
          <button class="col-auto ml-2 btn" nbButton (click)="onQuery()">
            <i class="fas fa-search"></i>
          </button>            
        </div> -->

        <div class="d-flex mx-0 mt-2 justify-content-between">         
          <nb-select class="col-auto pr-0 ml-auto" style="width:180px" 
              [(ngModel)]="selectPRDMenuNo" (selectedChange)="onQuery()">
              <nb-option *ngFor="let item of titleList" [value]="item.value">
                  {{ item.label }}
              </nb-option>
          </nb-select>         
        </div>

        <div class="mt-3">
          <table class="table table-bordered table-striped">
            <thead>
              <tr>
                <th>種類名稱</th>
                <th>菜單</th>
                <th>啟用</th>                
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngIf="mainDataList && mainDataList.length">
                <td> <b class="text-info">全選</b> </td>
                <td>  </td>
                <td>
                  <nb-toggle status="info" [(checked)]="status.isSelectAll" 
                    (checkedChange)="onSelectAllG()">
                  </nb-toggle>
                </td>
                <td>
                  <b class="text-info">已選{{status.AllSelectCount}}項</b>               
                </td>
              </tr>
              <ng-container *ngFor="let e of mainDataList ">
                <tr>
                  <td> {{ e.GroupName }}</td>  
                  <td style="vertical-align: middle;">{{e.Title}}</td>            
                  <td>
                    <nb-toggle status="info" [(checked)]="e.IsOK_Group" 
                      (checkedChange)="onSelectG(e.PRDMenuProductGroupNo)">
                    </nb-toggle>
                  </td>                 
                  <td>
                    <button nbButton class="m-0  col-sm-12"   
                      (click)="onOpenPd(e.PRDMenuProductGroupNo)">   
                        {{ e.CountStr ? e.CountStr : '選擇'}}</button>  
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </nb-card-body>
      <nb-card-footer>
        <button nbButton (click)="onSavePdG();">確定</button>
        <button nbButton (click)="ref.close()">取消</button>
      </nb-card-footer>
    </nb-card>
  </ng-template>
  
  
  <!-- 選擇產品 -->
  <ng-template #PdModal let-data let-ref="dialogRef">
    <nb-card class="staffInfoTemplate">
      <nb-card-header>
        選擇商品
      </nb-card-header>
      <nb-card-body class="staffInfoTemplate">
  
        <div class="mt-3">
          <table class="table table-bordered table-striped">
            <thead>
              <tr>
                <th>商品名稱</th>
                <th>啟用</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let e of showListPd">
                <tr>
                  <td> {{ e.ProductName }}
                  </td>
                  <td>
                    <nb-toggle status="info" class="" 
                      [(checked)]="e.IsOK_Product"
                      [disabled]="e.IsCanSelect == 0" >
                    </nb-toggle>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </nb-card-body>
      <nb-card-footer>
        <button nbButton (click)="onSavePd();">確定</button>
        <button nbButton (click)="ref.close()">取消</button>
      </nb-card-footer>
    </nb-card>
  </ng-template>